.button {
  padding: 6px 12px;
  cursor: pointer;
  background: none;
  border: 0.5px solid #949494;
  border-radius: 4px;
  font-size: inherit;
  white-space: nowrap;
}

.selected {
  border: 2px solid black;
}
